/* ============================================================
   AHUMIA · sistema de movimiento de la ficha de producto
   Un solo requestAnimationFrame para todo lo ligado al scroll.
   IntersectionObserver para las apariciones.
   Se engancha al contenedor que scrollea de verdad: el tema
   mueve .page-wrapper, no la ventana (L-039).
   Se apaga entero con prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  var d = document;
  var w = window;
  var root = d.documentElement;

  var REDUCE = !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var COARSE = !!(w.matchMedia && w.matchMedia('(pointer: coarse)').matches);

  root.classList.add('axm-on');
  if (REDUCE) root.classList.add('axm-reduce');

  function qs(sel, ctx) { return (ctx || d).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }
  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  function findScroller() {
    var pw = qs('.page-wrapper');
    if (pw && pw.scrollHeight > pw.clientHeight + 40) return pw;
    var list = qsa('body > div, main, #MainContent');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      var cs = w.getComputedStyle(el);
      if (/(auto|scroll)/.test(cs.overflowY) && el.scrollHeight > el.clientHeight + 40) return el;
    }
    return null;
  }
  var SC = findScroller();
  function scrollTop() { return SC ? SC.scrollTop : (w.pageYOffset || root.scrollTop || 0); }
  function viewH() { return SC ? SC.clientHeight : w.innerHeight; }
  function scrollMax() {
    var m = SC ? (SC.scrollHeight - SC.clientHeight) : (root.scrollHeight - w.innerHeight);
    return m > 0 ? m : 1;
  }

  /* ---------- 1 · APARICIONES ---------- */
  var io = null;
  if ('IntersectionObserver' in w) {
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var e = entries[i];
        if (e.isIntersecting) { e.target.classList.add('axm-in'); io.unobserve(e.target); }
      }
    }, { root: SC || null, rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
  }

  var pending = [];

  function reveal(el, variant, delay) {
    if (!el || el.classList.contains('axm-rv')) return;
    pending.push(el);
    el.classList.add('axm-rv');
    if (variant) el.classList.add('axm-rv--' + variant);
    if (delay) el.style.setProperty('--axm-d', delay + 'ms');
    if (io) io.observe(el); else el.classList.add('axm-in');
  }

  function revealGroup(sel, variant, step, ctx) {
    var els = qsa(sel, ctx);
    for (var i = 0; i < els.length; i++) reveal(els[i], variant, i * (step || 0));
  }

  function setupReveals() {
    // El bloque de compra entra por CSS (ahumia-motion.css, apartado 13):
    // asi no depende de cuando corra este script, ni de que corra.

    reveal(qs('.ax__inner > .ax__head'), null, 0);
    reveal(qs('.ax-story__media'), 'left', 60);
    revealGroup('.ax-story__steps > .ax-step', 'right', 110);
    revealGroup('.ax-inline-cta', null, 0);

    reveal(qs('.ax-wood .ax__head'), null, 0);
    reveal(qs('.ax-wood__left'), 'left', 60);
    reveal(qs('.ax-wood__shot'), 'right', 120);

    reveal(qs('.ax-pick .ax__head'), null, 0);
    revealGroup('.ax-pick__grid > .ax-card', 'zoom', 130);
    reveal(qs('.ax-pick__note'), null, 220);

    reveal(qs('.reora-split__media'), 'left', 0);
    reveal(qs('.reora-split__content-inner'), 'right', 90);
    revealGroup('.reora-split__spec', null, 70);

    reveal(qs('.reora-faq__header'), null, 0);
    revealGroup('.reora-faq__list > .reora-faq__item', null, 60);
  }

  /* ---------- 2 · TÍTULOS PALABRA A PALABRA ---------- */
  function splitWords(el, stepMs) {
    if (!el || el.dataset.axmSplit === '1') return;
    if (el.querySelector('img, svg, video')) return;
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    if (!text || text.length > 140) return;
    el.dataset.axmSplit = '1';
    var words = text.split(' ');
    var html = '';
    for (var i = 0; i < words.length; i++) {
      var safe = words[i].replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      html += '<span class="axm-word" style="--axm-d:' + (i * (stepMs || 46)) + 'ms">' + safe + '</span>';
      if (i < words.length - 1) html += ' ';
    }
    el.innerHTML = html;
  }

  function setupTitles() {
    var titles = [];
    var h1 = qs('.bn-pdp h1') || qs('.bn-pdp__title');
    if (h1) titles.push(h1);
    titles = titles.concat(qsa('.ax__title'));
    var sp = qs('.reora-split__heading');
    if (sp) titles.push(sp);
    for (var i = 0; i < titles.length; i++) {
      var t = titles[i];
      splitWords(t, 46);
      t.classList.add('axm-burn');
      var inHero = t.closest && t.closest('.bn-pdp');
      if (!inHero) reveal(t, null, 0);
    }
  }

  /* ---------- 3 · PROGRESO Y CARRIL ---------- */
  var chipNav = null;
  var railDots = [];
  var railTargets = [];

  function buildBar() {
    var bar = d.createElement('div');
    bar.className = 'axm-bar';
    bar.setAttribute('aria-hidden', 'true');
    var fill = d.createElement('div');
    fill.className = 'axm-bar__fill';
    bar.appendChild(fill);
    d.body.appendChild(bar);
  }

  function measureHeader() {
    var hdr = qs('[id*="header_section"]') || qs('header');
    var h = hdr ? Math.round(hdr.getBoundingClientRect().height) : 64;
    if (h < 30 || h > 160) h = 64;
    root.style.setProperty('--axm-chiptop', h + 'px');
  }

  function buildRail() {
    var here = 'The product';
    var path = location.pathname;
    if (/pack/.test(path)) here = 'The pack';
    else if (/soplete/.test(path)) here = 'The torch';
    else if (/kit/.test(path)) here = 'The kit';

    var map = [
      ['.bn-pdp', here],
      ['.ax-story', 'How it works'],
      ['.ax-wood', 'The woods'],
      ['.ax-pick', 'In the box'],
      ['.reora-split__bg', 'Details'],
      ['.reora-faq', 'FAQ']
    ];
    var found = [];
    for (var i = 0; i < map.length; i++) {
      var el = qs(map[i][0]);
      if (el) found.push({ el: el, label: map[i][1] });
    }
    if (found.length < 3) return;

    var nav = d.createElement('nav');
    nav.className = 'axm-chips';
    nav.setAttribute('aria-label', 'Page sections');
    var strip = d.createElement('div');
    strip.className = 'axm-chips__strip';
    nav.appendChild(strip);
    chipNav = nav;

    found.forEach(function (item) {
      var b = d.createElement('button');
      b.type = 'button';
      b.className = 'axm-chip';
      b.textContent = item.label;
      b.addEventListener('click', function () {
        var y = item.el.getBoundingClientRect().top + scrollTop() - 124;
        var opts = { top: y, behavior: REDUCE ? 'auto' : 'smooth' };
        if (SC) SC.scrollTo(opts); else w.scrollTo(opts);
      });
      strip.appendChild(b);
      railDots.push(b);
      railTargets.push(item.el);
    });

    d.body.appendChild(nav);
  }

  /* ---------- 4 · PARALLAX, HUMO, BARRA FIJA ---------- */
  var parallaxItems = [];
  var stickyEl = null;
  var stickyAnchor = null;
  var ticking = false;

  function collectParallax() {
    var defs = [
      ['.ax-story__frame img', 0.055],
      ['.ax-wood__shot img', 0.075],
      ['.reora-split__media img', 0.07],
      ['.ax-card__media img', 0.035]
    ];
    for (var i = 0; i < defs.length; i++) {
      var els = qsa(defs[i][0]);
      for (var j = 0; j < els.length; j++) parallaxItems.push({ el: els[j], f: defs[i][1] });
    }
  }

  function buildSmoke() {
    var stage = qs('.bn-gallery__stage');
    if (!stage || REDUCE) return;
    var layer = d.createElement('div');
    layer.className = 'axm-smoke';
    layer.setAttribute('aria-hidden', 'true');
    layer.innerHTML = '<i></i><i></i><i></i>';
    stage.insertBefore(layer, stage.firstChild);
  }

  function frame() {
    ticking = false;
    var top = scrollTop();
    var vh = viewH();
    var max = scrollMax();

    root.style.setProperty('--axm-progress', clamp(top / max, 0, 1).toFixed(4));
    root.style.setProperty('--axm-smoke', clamp(top / (vh * 1.2), 0, 1).toFixed(3));

    if (!REDUCE) {
      for (var i = 0; i < parallaxItems.length; i++) {
        var it = parallaxItems[i];
        var r = it.el.getBoundingClientRect();
        if (r.bottom < -120 || r.top > vh + 120) continue;
        var centre = r.top + r.height / 2 - vh / 2;
        it.el.style.transform = 'translate3d(0,' + (-centre * it.f).toFixed(2) + 'px,0)';
      }
    }

    if (railDots.length) {
      var best = 0, bestDist = Infinity;
      for (var k = 0; k < railTargets.length; k++) {
        var rr = railTargets[k].getBoundingClientRect();
        var dist = Math.abs(rr.top - vh * 0.32);
        if (rr.top < vh * 0.62 && dist < bestDist) { bestDist = dist; best = k; }
      }
      for (var m = 0; m < railDots.length; m++) railDots[m].classList.toggle('is-on', m === best);
    }

    if (pending.length) {
      var still = [];
      for (var q = 0; q < pending.length; q++) {
        var pe = pending[q];
        if (pe.classList.contains('axm-in')) continue;
        var pr = pe.getBoundingClientRect();
        if (pr.top < vh * 0.94 && pr.bottom > -80) pe.classList.add('axm-in');
        else still.push(pe);
      }
      pending = still;
    }

    if (stickyAnchor) {
      var ar = stickyAnchor.getBoundingClientRect();
      if (stickyEl) stickyEl.classList.toggle('axm-shown', ar.bottom < 40 && top < max - 220);
      if (chipNav) chipNav.classList.toggle('axm-shown', ar.bottom < 60 && top < max - 160);
    }
    return true;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    w.requestAnimationFrame(frame);
  }

  /* ---------- 5 · INCLINACIÓN 3D Y BRILLO ---------- */
  function setupTilt() {
    if (REDUCE || COARSE) return;
    var targets = []
      .concat(qsa('.bn-gallery__stage'))
      .concat(qsa('.ax-card__media'))
      .concat(qsa('.ax-wood__shot'))
      .concat(qsa('.reora-split__media'));

    targets.forEach(function (el) {
      if (!el) return;
      el.classList.add('axm-tilt');
      var raf = 0;
      el.addEventListener('pointermove', function (ev) {
        if (raf) return;
        raf = w.requestAnimationFrame(function () {
          raf = 0;
          var r = el.getBoundingClientRect();
          var px = (ev.clientX - r.left) / r.width;
          var py = (ev.clientY - r.top) / r.height;
          el.classList.add('axm-tilting');
          el.style.transform = 'perspective(1100px) rotateX(' + ((0.5 - py) * 7).toFixed(2) + 'deg) rotateY(' + ((px - 0.5) * 7).toFixed(2) + 'deg)';
        });
      }, { passive: true });
      el.addEventListener('pointerleave', function () {
        el.classList.remove('axm-tilting');
        el.style.transform = '';
      });
    });

    qsa('.ax-card, .reora-faq__item, .bn-pdp__block').forEach(function (el) {
      el.classList.add('axm-glow');
      el.addEventListener('pointermove', function (ev) {
        var r = el.getBoundingClientRect();
        el.style.setProperty('--axm-x', (((ev.clientX - r.left) / r.width) * 100).toFixed(1) + '%');
        el.style.setProperty('--axm-y', (((ev.clientY - r.top) / r.height) * 100).toFixed(1) + '%');
      }, { passive: true });
    });
  }

  /* ---------- 6 · BOTONES ---------- */
  function setupButtons() {
    var btns = []
      .concat(qsa('.bn-pdp__atc'))
      .concat(qsa('.ax-btn'))
      .concat(qsa('.ax-card__add'))
      .concat(qsa('.reora-sticky__form button'));

    btns.forEach(function (b) {
      if (!b) return;
      b.classList.add('axm-mag');
      if (REDUCE || COARSE) return;
      b.addEventListener('pointermove', function (ev) {
        var r = b.getBoundingClientRect();
        var dx = (ev.clientX - (r.left + r.width / 2)) / r.width;
        var dy = (ev.clientY - (r.top + r.height / 2)) / r.height;
        b.style.transform = 'translate3d(' + (dx * 8).toFixed(1) + 'px,' + (dy * 6).toFixed(1) + 'px,0)';
      }, { passive: true });
      b.addEventListener('pointerleave', function () { b.style.transform = ''; });
    });

    if (REDUCE) return;
    qsa('form[action*="/cart/add"]').forEach(function (f) {
      f.addEventListener('submit', function () {
        var btn = f.querySelector('[type="submit"]') || f.querySelector('button');
        if (!btn) return;
        var r = btn.getBoundingClientRect();
        for (var i = 0; i < 9; i++) {
          (function (n) {
            var p = d.createElement('span');
            p.className = 'axm-puff';
            p.style.left = (r.left + r.width * (0.2 + Math.random() * 0.6)) + 'px';
            p.style.top = (r.top + r.height * 0.5) + 'px';
            p.style.setProperty('--axm-dx', ((Math.random() - 0.5) * 90).toFixed(0) + 'px');
            p.style.animationDelay = (n * 45) + 'ms';
            d.body.appendChild(p);
            w.setTimeout(function () { if (p.parentNode) p.parentNode.removeChild(p); }, 1500);
          })(i);
        }
      });
    });
  }

  /* ---------- 7 · NÚMEROS QUE CUENTAN ---------- */
  function animateNumberIn(el, original, prefix, numStr, suffix) {
    var decSep = numStr.indexOf(',') > -1 ? ',' : (numStr.indexOf('.') > -1 ? '.' : '');
    var target = parseFloat(numStr.replace(/\./g, '').replace(/,/g, '.'));
    if (!isFinite(target)) { el.textContent = original; return; }
    var decimals = 0;
    if (decSep) {
      var parts = numStr.split(decSep);
      decimals = parts[parts.length - 1].length;
      if (decimals > 2) decimals = 0;
    }
    var dur = 900, t0 = 0;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = clamp((ts - t0) / dur, 0, 1);
      var v = target * (1 - Math.pow(1 - p, 3));
      var out = decimals ? v.toFixed(decimals).replace('.', decSep) : String(Math.round(v));
      el.textContent = prefix + out + suffix;
      if (p < 1) w.requestAnimationFrame(step); else el.textContent = original;
    }
    w.requestAnimationFrame(step);
  }

  function setupCounters() {
    if (REDUCE || !('IntersectionObserver' in w)) return;
    var targets = qsa('.reora-split__spec-value');
    var numIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        numIo.unobserve(e.target);
        var el = e.target;
        if (el.children.length) return;
        var original = el.textContent;
        var m = original.match(/^([^0-9]*)([0-9]{1,3}(?:[.,][0-9]+)?)([\s\S]*)$/);
        if (!m) return;
        w.setTimeout(function () { el.textContent = original; }, 1600);
        animateNumberIn(el, original, m[1], m[2], m[3]);
      });
    }, { root: SC || null, threshold: 0.5 });
    targets.forEach(function (el) { if (el) numIo.observe(el); });

    var priceEl = qs('.bn-pdp__price');
    if (priceEl) {
      var pIo = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          pIo.unobserve(e.target);
          e.target.classList.add('axm-price-pop');
        });
      }, { root: SC || null, threshold: 0.6 });
      pIo.observe(priceEl);
    }
  }

  /* ---------- 8 · GALERÍA ---------- */
  function setupGallery() {
    var track = qs('.bn-gallery__track');
    var stage = qs('.bn-gallery__stage');
    if (!track || !stage) return;

    var slides = qsa('.bn-gallery__slide', track);
    if (slides.length > 1) {
      var badge = d.createElement('span');
      badge.className = 'axm-count';
      badge.setAttribute('aria-hidden', 'true');
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      badge.textContent = pad(1) + ' / ' + pad(slides.length);
      stage.appendChild(badge);
      var update = function () {
        var i = clamp(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) + 1, 1, slides.length);
        badge.textContent = pad(i) + ' / ' + pad(slides.length);
      };
      track.addEventListener('scroll', function () { w.requestAnimationFrame(update); }, { passive: true });
    }

    if (COARSE) return;

    var down = false, startX = 0, startLeft = 0, moved = 0;
    track.addEventListener('pointerdown', function (ev) {
      if (ev.button !== 0) return;
      down = true; moved = 0;
      startX = ev.clientX;
      startLeft = track.scrollLeft;
      track.classList.add('axm-drag');
    });
    track.addEventListener('pointermove', function (ev) {
      if (!down) return;
      var dx = ev.clientX - startX;
      moved = Math.abs(dx);
      track.scrollLeft = startLeft - dx;
    }, { passive: true });
    var release = function () {
      if (!down) return;
      down = false;
      track.classList.remove('axm-drag');
      var wd = Math.max(1, track.clientWidth);
      track.scrollTo({ left: Math.round(track.scrollLeft / wd) * wd, behavior: REDUCE ? 'auto' : 'smooth' });
    };
    track.addEventListener('pointerup', release);
    track.addEventListener('pointercancel', release);
    track.addEventListener('pointerleave', release);
    track.addEventListener('click', function (ev) {
      if (moved > 8) { ev.preventDefault(); ev.stopPropagation(); }
    }, true);
  }

  /* ---------- 9 · PREGUNTAS ---------- */
  function setupFaq() {
    qsa('details.reora-faq__item').forEach(function (det) {
      var sum = det.querySelector('summary');
      var body = det.querySelector('.reora-faq__a');
      if (!sum || !body) return;
      body.style.overflow = 'hidden';
      if (!det.open) body.style.height = '0px';

      sum.addEventListener('click', function (ev) {
        if (REDUCE) return;
        ev.preventDefault();
        if (det.dataset.axmBusy === '1') return;
        det.dataset.axmBusy = '1';
        var finish = function () { det.dataset.axmBusy = '0'; body.style.transition = ''; };

        if (det.open) {
          body.style.height = body.scrollHeight + 'px';
          body.getBoundingClientRect();
          body.style.transition = 'height .34s cubic-bezier(.22,1,.36,1)';
          body.style.height = '0px';
          w.setTimeout(function () { det.open = false; finish(); }, 350);
        } else {
          det.open = true;
          body.style.height = '0px';
          body.getBoundingClientRect();
          body.style.transition = 'height .34s cubic-bezier(.22,1,.36,1)';
          body.style.height = body.scrollHeight + 'px';
          w.setTimeout(function () { body.style.height = 'auto'; finish(); }, 350);
        }
      });
    });
  }

  function setupSticky() {
    stickyEl = qs('reora-sticky') || qs('.reora-sticky');
    stickyAnchor = qs('.bn-pdp__form') || qs('.bn-pdp__details');
  }

  /* ---------- ARRANQUE ---------- */
  function init() {
    setupTitles();
    setupReveals();
    buildBar();
    measureHeader();
    buildRail();
    collectParallax();
    buildSmoke();
    setupTilt();
    setupButtons();
    setupCounters();
    setupGallery();
    setupFaq();
    setupSticky();

    var opts = { passive: true };
    if (SC) SC.addEventListener('scroll', onScroll, opts);
    w.addEventListener('scroll', onScroll, opts);
    w.addEventListener('resize', function () { measureHeader(); onScroll(); }, opts);
    d.addEventListener('visibilitychange', onScroll);

    onScroll();
    w.setTimeout(onScroll, 400);
    w.setTimeout(onScroll, 1200);

    w.setTimeout(function () {
      qsa('.axm-rv').forEach(function (el) {
        if (el.getBoundingClientRect().top < viewH()) el.classList.add('axm-in');
      });
    }, 1200);

    // Si el navegador estaba en segundo plano, al volver se recalcula todo.
    d.addEventListener('visibilitychange', function () { if (!d.hidden) onScroll(); });

    w.axmSync = frame;
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
})();
